import { Helmet } from 'react-helmet';
import seo from '../../data';

const SEO_METATAGS = () => {
	console.log({ seo });

	return (
		<>
			<Helmet>
				<title>{seo.companyName}</title>
				<meta
					name='description'
					content={seo.site.description || ''}
				/>
				<meta
					name='keywords'
					content={seo.site.keywords || ''}
				/>
				<meta
					name='author'
					content={seo.companyName || ''}
				/>

				<meta
					name='viewport'
					content={seo.site.viewport || ''}
				/>
				<meta charset='UTF-8' />
				{/* Open Graph Meta Tags for Social Media */}
				<meta
					property='og:title'
					content={seo.site.title || ''}
				/>
				<meta
					property='og:description'
					content={seo.companyName || ''}
				/>
				<meta
					property='og:type'
					content='website'
				/>

				{seo.site.url && (
					<meta
						property='og:url'
						content={seo.site.url}
					/>
				)}
				<meta
					property='og:image'
					content={seo.img.favicon}
				/>
				<meta
					property='og:site_name'
					content={seo.site.title}
				/>
				<meta
					property='og:locale'
					content='en_US'
				/>
				{/* Twitter Card Meta Tags */}
				<meta
					name='twitter:card'
					content='summary_large_image'
				/>
				<meta
					name='twitter:title'
					content={seo.site.companyName}
				/>
				<meta
					name='twitter:description'
					content={seo.site.description}
				/>
				{/* 
				<meta
					name='twitter:image'
					content={seo.img.twitter}
				/>
				<meta
					name='twitter:site'
					content={seo.social.twitter.username}
				/>
				<meta
					name='twitter:creator'
					content={seo.dev.twitter.username}
				/> */}
				{/* Language & Location */}
				<meta
					name='content-language'
					content='en-us'
				/>
				<meta
					name='geo.region'
					content={seo.location_language.region}
				/>
				<meta
					name='geo.placename'
					content={seo.location_language.placename}
				/>
				<meta
					name='geo.position'
					content={seo.location_language.position}
				/>
				{/* Mobile Optimization
				 */}
				<meta
					name='mobile-web-app-capable'
					content='yes'
				/>
				<meta
					name='apple-mobile-web-app-capable'
					content='yes'
				/>
				<meta
					name='apple-mobile-web-app-status-bar-style'
					content='black'
				/>
				{/* Cache Control */}
				<meta
					http-equiv='cache-control'
					content='no-cache'
				/>
			</Helmet>
		</>
	);
};
export default SEO_METATAGS;
